import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export const activateDependentById = async (userId: number, dependent_id: number): Promise<UserProfile> => {
  const { data } = await client.patch<UserProfile>(`/users/${userId}/dependents/${dependent_id}/reactivate`);

  return data;
};
